import React from 'react';
import Logo from '../../assets/images/logonova.png';
import { Button, LightRays } from '../ui';

function HeroSection() {
  return (
    <section id="hero" className="hero-section min-vh-100 d-flex justify-content-center align-items-center text-center">
      {/* Light Rays Background */}
      <LightRays
        raysOrigin="top-center"
        raysColor="#7a9d8b"
        raysSpeed={0.6}
        lightSpread={1.2}
        rayLength={3.5}
        followMouse={true}
        mouseInfluence={0.2}
        noiseAmount={0.03}
        distortion={0.15}
        pulsating={true}
        fadeDistance={1.5}
        saturation={1.2}
      />

      <div className="hero-content">
        {/* Logo */}
        <div className="hero-logo mb-4">
          <img
            src={Logo}
            alt="Igreja Casa de Oracao"
            className="hero-logo-img"
          />
        </div>

        {/* Botoes */}
        <div className="d-flex gap-3 justify-content-center mt-4 flex-wrap">
          {/* <Button
            onClick={() => window.location.href = "#evento"}
            variant="primary"
            size="lg"
          >
            <i className="bi bi-stars me-2"></i>
            3o Aniversario
          </Button> */}
          <Button
            onClick={() => window.location.href = "#agenda"}
            variant="outline"
            size="lg"
          >
            Agenda
          </Button>
          <Button
            onClick={() => window.location.href = "#doacoes"}
            variant="ghost"
            size="lg"
          >
            Faca sua doacao
          </Button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
